import { render } from "./FridgeDetailsRadioButton.vue?vue&type=template&id=212fa2c0&scoped=true&ts=true"
import script from "./FridgeDetailsRadioButton.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsRadioButton.vue?vue&type=script&lang=ts"

import "./FridgeDetailsRadioButton.vue?vue&type=style&index=0&id=212fa2c0&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212fa2c0"]])

export default __exports__